const wanjia = {
  // 万家商品级采购价分页查询
  goodsPurchasePrice: {
    type: 'post',
    url: '/ec-pc-api/product/purchasePrice/goodsPurchasePrice'
  },
  // 万家采购价分页查询
  listPage: {
    type: 'post',
    url: '/ec-pc-api/product/purchasePrice/listPage'
  },
  // 万家采购价历史分页查询
  listPageHistory: {
    type: 'post',
    url: '/ec-pc-api/product/purchasePrice/listPageHistory'
  },
  // 万家采购价新增修改
  purchasePriceSaveOrUpdate: {
    type: 'post',
    url: '/ec-pc-api/product/purchasePrice/purchasePriceSaveOrUpdate'
  },
  // 通过商品查询产品的价格
  getProductCodePriceByGoods: {
    type: 'get',
    url: '/ec-pc-api/product/purchasePrice/getProductCodePriceByGoods'
  }
};

export default wanjia;
